import React from 'react';
import { Button } from './ui/button';
import { contactInfo } from '../data/mockData';
import { MapPin, Phone, Mail } from 'lucide-react';

const CTASection = () => {
  return (
    <section className="py-16 md:py-24 bg-white relative overflow-hidden">
      <div className="container mx-auto px-6">
        <div className="grid md:grid-cols-2 gap-8 md:gap-12 items-start">
          {/* Left side - Contact info aligned with title */}
          <div className="relative text-center md:text-left order-2 md:order-1">
            {/* Contact information - moved up to align with title */}
            <div className="space-y-3 md:space-y-4 bg-gray-50 rounded-2xl p-4 md:p-6 mb-6 md:mb-8">
              <div className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-[#FF6347] mt-1 flex-shrink-0" />
                <div className="text-left">
                  <p className="font-bold text-[#1A4D4D] text-sm md:text-base">{contactInfo.location}</p>
                  <p className="text-gray-600 text-xs md:text-sm">{contactInfo.address}</p>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <Phone className="w-5 h-5 text-[#FF6347] flex-shrink-0" />
                <a
                  href={`tel:${contactInfo.phone}`}
                  className="text-gray-600 hover:text-[#FF6347] transition-colors duration-200 text-sm md:text-base"
                >
                  {contactInfo.phone}
                </a>
              </div>
              <div className="flex items-center gap-3">
                <Mail className="w-5 h-5 text-[#FF6347] flex-shrink-0" />
                <a
                  href={`mailto:${contactInfo.email}`}
                  className="text-gray-600 hover:text-[#FF6347] transition-colors duration-200 text-sm md:text-base"
                >
                  {contactInfo.email}
                </a>
              </div>
            </div>

            {/* Illustration of children */}
            <div className="flex justify-center md:justify-start">
              <svg className="w-32 h-24 md:w-48 md:h-36" viewBox="0 0 200 150" fill="none">
                {/* Child 1 - jumping */}
                <ellipse cx="60" cy="60" rx="28" ry="32" fill="#FFD580" />
                <circle cx="60" cy="48" r="20" fill="#1A4D4D" />
                <rect x="45" y="85" width="30" height="40" rx="6" fill="#FFE090" />
                <rect x="40" y="118" width="12" height="22" rx="4" fill="#FFE090" />
                <rect x="68" y="118" width="12" height="22" rx="4" fill="#FFE090" />
                
                {/* Child 2 - standing */}
                <ellipse cx="130" cy="70" rx="30" ry="35" fill="#5DADE2" />
                <circle cx="130" cy="55" r="22" fill="#1A4D4D" />
                <rect x="113" y="95" width="34" height="45" rx="7" fill="#6DB8E8" />
                <rect x="108" y="132" width="14" height="18" rx="4" fill="#6DB8E8" />
                <rect x="128" y="132" width="14" height="18" rx="4" fill="#6DB8E8" />
              </svg>
            </div>
          </div>

          {/* Right side - Combined "Kom kennismaken met onze zorg" */}
          <div className="text-center md:text-left order-1 md:order-2">
            <h2
              className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-[#1A4D4D] mb-4 md:mb-6 leading-tight"
              style={{ fontFamily: 'Fredoka, Quicksand, sans-serif' }}
            >
              Kom kennismaken met onze zorg.
            </h2>
            <p className="text-gray-600 text-base md:text-lg mb-6 md:mb-8 leading-relaxed">
              We nodigen u graag uit voor een kennismaking en rondleiding in onze aanleunwoning. Tijdens de intake bespreken we de mogelijkheden, uw vragen en wensen. Neem gerust contact met ons op voor meer informatie of om een afspraak te maken.
            </p>

            <div className="flex flex-col sm:flex-row gap-3 md:gap-4 items-center justify-center md:justify-start">
              <a href="mailto:info@kscare.nl?subject=Intake%20aanvraag" className="w-full sm:w-auto">
                <Button
                  className="w-full sm:w-auto bg-[#FF6347] hover:bg-[#FF5533] text-white rounded-full px-6 md:px-8 py-5 md:py-6 text-base md:text-lg transition-all duration-300 hover:shadow-xl hover:scale-105"
                >
                  Plan een intake
                </Button>
              </a>
              <span className="text-gray-400 font-medium text-sm">of</span>
              <a href="mailto:info@kscare.nl?subject=Vraag%20over%20KS%20Care" className="w-full sm:w-auto">
                <Button
                  variant="outline"
                  className="w-full sm:w-auto border-2 border-[#1A4D4D] text-[#1A4D4D] hover:bg-[#1A4D4D] hover:text-white rounded-full px-6 md:px-8 py-5 md:py-6 text-base md:text-lg transition-all duration-300 hover:shadow-xl"
                >
                  Stel een vraag
                </Button>
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Decorative leaves */}
      <div className="absolute top-20 right-20 opacity-20 hidden xl:block">
        <svg width="60" height="80" viewBox="0 0 60 80" fill="none">
          <path d="M30 0C30 0 50 20 30 80C30 80 10 20 30 0Z" fill="#52BE80" />
        </svg>
      </div>
      <div className="absolute bottom-20 left-20 opacity-20 hidden xl:block">
        <svg width="50" height="70" viewBox="0 0 50 70" fill="none">
          <path d="M25 0C25 0 45 15 25 70C25 70 5 15 25 0Z" fill="#FFD580" />
        </svg>
      </div>
    </section>
  );
};

export default CTASection;